import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
} from './agenda-task.action';
import { AgendaTask, TaskCategory, TaskStatus, TaskFile } from './agenda-task.model';

export interface AgendaTaskRecordsState {
    listData: any[];
    singleData: AgendaTask;
    loading: boolean;
    error: any;
    total: number;
    statuses: TaskStatus[];
    categories: TaskCategory[];
    dummyId: string;
    files: TaskFile[];
}

export const initialState: AgendaTaskRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    statuses: [],
    categories: [],
    dummyId: "",
    files: []
};

export const agendaTaskReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),

    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { dummyId, singleData, files, statuses, categories }) => {
        return { ...state, dummyId, singleData, files, statuses, categories, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
);